<template>
  <div class="control_box" :class="{ wrong: passData.wrong }" ref="controlBox">
    <div class="label">{{passData.label}}</div>
    <div class="control" :class="`_${passData.controlType}`">
      <template v-if="passData.controlType === 'password'">
        <input :type="passData.showPassword ? 'text' : 'password'" v-model="value" @blur="blur" :placeholder="placeholder">
        <div class="suf-icon" @click="update_self('showPassword', !passData.showPassword)">
          <img v-show="!passData.showPassword" src="@img/control/eye.svg">
          <img v-show="passData.showPassword" src="@img/control/eye-close.svg">
        </div>
      </template>
      <template v-else>
        <input :type="passData.type === 'email' ? 'email' : 'text'" v-model="value" :inputmode="passData.key === 'email' ? 'email' : ''" @blur="blur" :placeholder="placeholder">
      </template>
    </div>
    <div v-if="passData.warn" class="msg">{{passData.warn}}</div>
  </div>
</template>

<script>
export default {
  props: {
    passData: Object,
    update: Function,
    check: Function,
  },
  computed: {
    placeholder() {
      let result = undefined;
      if (this.passData.placeholder) {
        result = this.passData.placeholder(this.passData.label);
      }
      return result;
    },
    value: {
      get() {
        return this.passData.value;
      },
      set(newValue) {
        this.update_self("value", newValue);
        this.check(this.passData.key);
      }
    },
  },
  methods: {
    blur() {
      this.check(this.passData.key, true);
    },
    update_self(key, newValue) {
      let setValue = newValue;

      if (this.passData.key === 'email') {
        setValue = newValue.toLowerCase();
      }

      this.update(this.passData.key, key, setValue);
    }
  }
}
</script>

<style lang="scss">
.control_box {
  &.wrong {
    input {
      border-color: red !important;
    }
  }
  & + .control_box {
    margin-top: 1.2rem;
  }
  & + .forgetPwd {
    margin-top: 0.3rem;
  }
  .label {
    font-size: 70%;
    color: $gray_60;
    margin-bottom: 0.2rem;
    line-height: 1;
  }
  input {
    border-bottom: 1px solid $gray_90;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  .msg {
    color: red;
    font-size: 70%;
    margin-top: 0.2rem;
  }
  //
  .control {
    position: relative;
    &._password {
      input {
        padding-right: 1.6rem;
      }
    }
    .suf-icon {
      @include buttonEnhance();
      @include common-click();
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      padding: 0 0.3rem;
      > img {
        width: 1rem;
      }
    }
  }
  input {
    height: 1.5rem;
    width: 100%;
    font-size: 90%;
    border-bottom: 1px solid $gray_90;
    &::placeholder {
      color: #9e9e9e;
    }
    &:focus {
      border-color: $main;
    }
  }
}
.forgetPwd {
  display: flex;
  justify-content: flex-end;
  & + .control_box {
    margin-top: 0.8rem;
  }
  > span {
    @include buttonEnhance();
    @include common-click();
    display: inline-block;
    font-size: 60%;
    color: $main;
  }
}
</style>